import React, { useState, useEffect, useRef } from 'react';

import { Tab, Tabs, Modal, Row, Col, Button, Form, Accordion, Table, Dropdown } from 'react-bootstrap';
import Select from 'react-select';
import { MultiSelect } from 'react-multi-select-component';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCircleXmark, faPencilAlt, faPaperclip, faFileArrowDown, faFileLines, faDownload, faPaperPlane, faXmark, faStar } from '@fortawesome/free-solid-svg-icons';

import firstImage from '../../../../assets/images/warehouse.png';
import secondImage from '../../../../assets/images/information.png';
import Docmnt from '../../../../assets/images/google-docs.png';
import Trash from '../../../../assets/images/trash.png';
import MailGreen from '../../../../assets/images/mail_green.png';
import MailRed from '../../../../assets/images/mail_red.png';
import { toast } from 'react-toastify';

import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import { GETDESTINATION, GETOWNERCODE, GETSHC, RECOVERYDETAILS, SAVEHANDLER, SAVERECOVERY, SROPENCLOSE, STATIONHANDLER, STATIONLIST, ULDADDRESSSAVE } from '../../../../Utils/conts.js';
import { CallApi } from '../../../../Components/common/CommonFunctions.js';

const Details = ({ allData, trigger, onChildAction, onFormEdit }) => {

    const isMounted = useRef(false);
    const [formData, setFormData] = useState({ all_stations: [], origin_notify_status: 1, destination_notify_status: 1 });

    const [isEditable, setIsEditable] = useState(false);
    const [formEdit, setFormEdit] = useState(false);

    const [originHandler, setOriginHandler] = useState([]);
    const [selectedOriginId, setSelectedOriginId] = useState(null);
    const [selectedOriginHandler, setSelectedOriginHandler] = useState(null);
    const [getOwnerCodes, setGetOwnerCode] = useState([]);
    const [getDestination, setGetDestination] = useState([]);
    const [destinationHandler, setDestinationHandler] = useState([]);
    const [selectedDestinationId, setSelectedDestinationId] = useState(null);
    const [selectedDestinationHandler, setSelectedDestinationHandler] = useState(null);

    const [reportHandler, setReportHandler] = useState([]);
    const [selectedReportId, setSelectedReportId] = useState(null);
    const [selectedReportHandler, setSelectedReportHandler] = useState(null);

    const [addressFor, setAddressFor] = useState('');
    const [handlerList, setHandlerList] = useState([]);
    const [inputAddress, setInputAddress] = useState({
        handler_org_id: '', address: '', handler_email_id: [''], handler_phone_no: ''
    });
    const [stations, setStations] = useState([
        // { station: '', stationHandler: [], selectedDestinationHandler: null }
    ]);

    const [commodityType, setCommodityType] = useState([]);
    const [movementType, setMovementType] = useState([]);
    const [recoveryAspects, setRecoveryAspects] = useState([]);
    const [otherAspects, setOtherAspects] = useState([]);
    const [recoveryInfo, setRecoveryInfo] = useState([]);

    const [addressModalShow, setAddressModalShow] = useState(false);
    const [address, setAddress] = useState([]);
    const [getShc, setGetShc] = useState([]);
    const addressModalClose = () => { setAddressModalShow(false); setInputAddress({ handler_org_id: '', address: '', handler_email_id: [''], handler_phone_no: '' }) }

    const fetchStationData = async () => {
        try {

            const res = await withRFSToken.post(STATIONLIST, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.port_code,
                        label: item.port_code,
                        address: item.address,
                        station_id: item.station_id
                    })) : [];
                    setGetDestination(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchAddressData = async (id) => {

        try {

            const res = await withRFSToken.post(STATIONHANDLER, { stationId: id })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.handler_org_id,
                        label: item.org_name,
                        email: item.handler_email_id
                    })) : [];
                    setHandlerList(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchOwnerCode = async () => {
        try {

            const res = await withRFSToken.post(GETOWNERCODE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.IATA,
                        label: item.IATA,
                        pref: item.AWB_prefix
                    })) : [];
                    setGetOwnerCode(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchRecoveryInformation = async (awbNumber) => {
        try {
            const res = await withRFSToken.post("service-recovery/recovery-information", { airway_bill: awbNumber });
            if (res.data.response_code === 200 && res.data.response_data != null) {
                const innerData = res.data.response_data;
                setFormData(innerData);
            }

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDropdown = async () => {
        try {

            const res = await withRFSToken.post('service-recovery/dropdown-list', {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setCommodityType(innerData.commodity_type);
                    setMovementType(innerData.movement_type);
                    setRecoveryAspects(innerData.recovery_aspects);
                    setRecoveryInfo(innerData.recovery_information);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchSHC = () => {
        CallApi({
            endPoint: GETSHC,
            payload: {},
            onSuccess: (res) => {
                const resCode = res.data.response_code;
                if (resCode === 200) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.value,
                        label: item.code,
                    })) : [];
                    setGetShc(transformedData);
                }
            },
            onError: (msg) => toast.error(msg)
        });
    };
    const fetchSpec = async () => {
        try {

            const res = await withRFSToken.post('get-meta-list', { type_id: '25' })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setOtherAspects(innerData)
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        if (isMounted.current) return;
        fetchDropdown();
        fetchAddressData();
        fetchOwnerCode();
        fetchStationData();
        fetchSHC();
        fetchSpec();
        if (allData) {
            const { attachments, ...rest } = allData;
            setFormData(rest)
        }
        isMounted.current = true;
    }, []);

    const orgDetails = JSON.parse(localStorage.getItem('Handler_stn'));
    console.log('orgDetails', orgDetails);

    useEffect(() => {
        const { attachments, ...rest } = allData;
        setFormData(rest);
        if (isEditable) { setIsEditable(false) }
    }, [allData, trigger]);

    useEffect(() => {
        // const storedData = JSON.parse(localStorage.getItem('RecoveryEdit'));
        if (formData?.reported) {
            const selectedDestination = getDestination.find(option => option.value === formData?.reported);
            console.log('selectedDestination', selectedDestination);
            if (selectedDestination) {
                setReportHandler(selectedDestination.address);
                setSelectedReportId(selectedDestination.station_id);
                if (formData?.reported_handler_id) {
                    const selectedOH = selectedDestination.address.find(option => option.id === formData?.reported_handler_id)

                    if (selectedOH) {
                        setSelectedReportHandler({
                            value: selectedOH.id,
                            label: selectedOH.company_name,
                            email: selectedOH.handler_email_id,
                            address: selectedOH.address,
                            number: selectedOH.handler_phone_no,
                            id: selectedOH.id,
                            hoid: selectedOH.handler_org_id,
                        })
                    }
                }
            } else {
                setReportHandler([]);
                setSelectedReportId(null);
                setSelectedReportHandler(null);
            }
        }
        if (formData?.origin) {
            const selectedDestination = getDestination.find(option => option.value === formData?.origin);
            if (selectedDestination) {
                setOriginHandler(selectedDestination.address);
                setSelectedOriginId(selectedDestination.station_id);
                if (formData?.origin_handler_id) {
                    const selectedOH = selectedDestination.address.find(option => option.id === formData?.origin_handler_id)
                    if (selectedOH) {
                        setSelectedOriginHandler({
                            value: selectedOH.id,
                            label: selectedOH.company_name,
                            email: selectedOH.handler_email_id,
                            address: selectedOH.address,
                            number: selectedOH.handler_phone_no,
                            id: selectedOH.id,
                            hoid: selectedOH.handler_org_id,
                        })
                    }
                }
            } else {
                setOriginHandler([]);
                setSelectedOriginId(null);
                setSelectedOriginHandler(null);
            }
        }
        if (formData?.destination) {
            const selectedDestination = getDestination.find(option => option.value === formData?.destination);

            if (selectedDestination) {
                setDestinationHandler(selectedDestination.address);
                setSelectedDestinationId(selectedDestination.station_id);
                if (formData?.destination_handler_id) {
                    const selectedOH = selectedDestination.address.find(option => option.id === formData?.destination_handler_id)
                    if (selectedOH) {
                        setSelectedDestinationHandler({
                            value: selectedOH.id,
                            label: selectedOH.company_name,
                            email: selectedOH.handler_email_id,
                            address: selectedOH.address,
                            number: selectedOH.handler_phone_no,
                            id: selectedOH.id,
                            hoid: selectedOH.handler_org_id,
                        })
                    }
                }
            } else {
                setDestinationHandler([]);
                setSelectedDestinationId(null);
                setSelectedDestinationHandler(null);
            }
        }
        // if (localStorage.getItem('RecoveryEdit')) {
        //     if (formData.all_stations && formData.all_stations.length > 0) {
        //         const initialStations = formData.all_stations.map(station => ({
        //             station: station.station_name || '',
        //             station_id: getDestination.find(dest => dest.value === station.station_name)?.station_id || '',
        //             stationHandler: station.handler_id ? getDestination.find(dest => dest.value === station.station_name)?.address || [] : [],
        //             selectedDestinationHandler: station.handler_id ? { value: station.handler_id, label: station.handler_name } : null,
        //             notifyChecked: station.notify_status === '1'
        //         }));
        //         setStations(initialStations);
        //     }
        // }
        if (localStorage.getItem('RecoveryEdit')) {
            if (formData?.all_stations && formData?.all_stations.length > 0) {
                const initialStations = formData?.all_stations.map(station => {
                    const matchingDestination = getDestination.find(dest => dest.value === station.station_name);

                    // `stationHandler` is populated based on `station.handler_id` and `station_name` matching in `getDestination`
                    const stationHandler = station.handler_id && matchingDestination ? matchingDestination.address || [] : [];

                    // `selectedDestinationHandler` uses `find` to locate the first matching handler by `handler_id`
                    const handlerData = stationHandler.find(handler => handler.id === station.handler_id);

                    const selectedDestinationHandler = handlerData ? {
                        value: handlerData.id,
                        label: handlerData.company_name,
                        email: handlerData.handler_email_id,
                        address: handlerData.address,
                        number: handlerData.handler_phone_no,
                        id: handlerData.id,
                        hoid: handlerData.handler_org_id,
                        station_id: handlerData.station_id
                    } : null;

                    return {
                        station: station.station_name || '',
                        station_id: matchingDestination?.station_id || '',
                        stationHandler,
                        selectedDestinationHandler, // Set transformed handler data as an object here
                        notifyChecked: station.notify_status === '1'
                    };
                });

                setStations(initialStations);
            }
        }

    }, [getDestination]);

    // ALL FORM
    const handleInputChange = (event) => {
        const { name, value, type, checked } = event.target;

        let newValue = type === 'checkbox' ? checked : value;
        // setTabChange(true);
        onFormEdit(true);
        setFormEdit(true)
        // if (name == 'origin_notify_status') {
        //     console.log('000', checked);

        //     setFormData(prevFormData => ({
        //         ...prevFormData,
        //         origin_notify_status: checked == true ? 1 : 0
        //     }));
        // } else if (name == 'destination_notify_status') {
        //     setFormData(prevFormData => ({
        //         ...prevFormData,
        //         destination_notify_status: checked == true ? 1 : 0
        //     }));
        // }

        if (name === 'master_airway_bill_prefix') {
            // const awbpref = getOwnerCodes?.find(prf => prf.AWB_prefix == value)
            if (value.length === 3) {
                const awbpref = getOwnerCodes?.find(prf => prf.pref === value);
                if (awbpref) {
                    // Update formData with the found flight_prefix
                    setFormData(prevFormData => ({
                        ...prevFormData,
                        master_airway_bill_prefix: value,
                        flight_prefix: awbpref.value
                    }));
                    return; // Exit early to avoid re-setting formData again below
                }
            } else {
                setFormData(prevFormData => ({
                    ...prevFormData,
                    master_airway_bill_prefix: value,
                    flight_prefix: ''
                }));
            }
        }
        if (name === 'master_airway_bill_no') {
            // Remove non-digits, and ensure it doesn't exceed 8 digits
            newValue = handleChange(value);
            const rawValue = newValue.replace(/\D/g, '');
            if (rawValue.length === 8 && formData.master_airway_bill_prefix?.length === 3) {
                const fullAWB = `${formData.master_airway_bill_prefix}-${rawValue}`;
                fetchRecoveryInformation(fullAWB);
            }

        }
        setFormData(prevFormData => {
            // const updatedAwbill1 = name === 'awbill1' ? newValue : prevFormData.awbill1 || '';
            // const updatedAwbill2 = name === 'awbill2' ? newValue : prevFormData.awbill2 || '';

            // return {
            //     ...prevFormData,
            //     [name]: newValue,
            //     master_airway_bill_no: `${updatedAwbill1}-${updatedAwbill2}`
            // };
            // When awbill1 or awbill2 is changed, update master_airway_bill_no
            // if (name === 'awbill1' || name === 'awbill2') {
            //     const newAirwayBill = `${formData.awbill1 || ''}-${formData.awbill2 || ''}`;

            //     return {
            //         ...prevFormData,
            //         [name]: newValue,
            //         master_airway_bill_no: newAirwayBill
            //     };
            // }
            if (name === 'recovery_aspects') {
                const updatedAspects = checked
                    ? [...(prevFormData.recovery_aspects || []), value] // Add the value if checked
                    : (prevFormData.recovery_aspects || []).filter(item => item !== value); // Remove the value if unchecked

                return {
                    ...prevFormData,
                    recovery_aspects: updatedAspects
                };
            }
            return { ...prevFormData, [name]: newValue };
        });
    };
    const handleChange = (value) => {
        // console.log(value);

        value = value.replace(/[^\d]/g, ''); // Remove any non-numeric characters
        let formattedValue = '';

        // Add a space after the first 4 digits
        if (value.length > 4) {
            formattedValue += value.substr(0, 4) + ' ';
            value = value.substr(4);
        }

        formattedValue += value;
        return formattedValue.substr(0, 9); // Limit to 9 characters (8 digits + 1 space)
    };
    // ALL FORM

    const handleToggleEdit = () => {
        if (isEditable) {
            handleFinish();
        } else {
            setIsEditable(true)
        }
    }

    // ADDRESS MODAL

    const addressModalOpen = (addressType, slst, idx) => {
        if (addressType == 'origin') {
            fetchAddressData(selectedOriginId)
        } else if (addressType == 'destination') {
            fetchAddressData(selectedDestinationId)
        } else if (addressType == 'station') {
            const findId = stations[idx].station_id;
            fetchAddressData(findId)
        }
        if (addressType == 'OH') {
            setInputAddress({
                handler_org_id: selectedOriginHandler.hoid,
                address: selectedOriginHandler.address,
                // handler_email_id: selectedOriginHandler.email,
                handler_email_id: Array.isArray(selectedOriginHandler.email) && selectedOriginHandler.email.length === 0 ? [''] : selectedOriginHandler.email,
                handler_phone_no: selectedOriginHandler.number,
                handler_contact_id: selectedOriginHandler?.id,
            });
        } else if (addressType == 'DH') {
            setInputAddress({
                handler_org_id: selectedDestinationHandler.hoid,
                address: selectedDestinationHandler.address,
                // handler_email_id: selectedDestinationHandler.email,
                handler_email_id: Array.isArray(selectedDestinationHandler.email) && selectedDestinationHandler.email.length === 0 ? [''] : selectedDestinationHandler.email,
                handler_phone_no: selectedDestinationHandler.number,
                handler_contact_id: selectedDestinationHandler?.id,
            });
        } else if (addressType == 'SH') {
            setInputAddress({
                handler_org_id: slst?.hoid,
                address: slst?.address,
                // handler_email_id: slst?.email,
                handler_email_id: Array.isArray(slst?.email) && slst?.email.length === 0 ? [''] : slst?.email,
                handler_phone_no: slst?.number,
                handler_contact_id: slst?.id,
            });
        }
        setSelectedStation(slst);
        setAddressFor(addressType);
        setAddressModalShow(true);
    }
    let orgLabel;
    if (selectedOriginId) {
        const idMatch = getDestination.find(option => option.station_id == selectedOriginId);
        orgLabel = idMatch.label;
    }
    let destLabel;
    if (selectedDestinationId) {
        const idMatch = getDestination.find(option => option.station_id == selectedDestinationId);
        destLabel = idMatch.label;
    }
    const handleAddressChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === 'checkbox' && name === 'regd') {
            setInputAddress({ ...inputAddress, [name]: checked ? '1' : '0' });
        } else {
            setInputAddress({ ...inputAddress, [name]: value });
        }
        console.log(inputAddress);
    };
    // ADDRESS MODAL

    // STATION SECTION
    const [selectedStation, setSelectedStation] = useState({});
    const handleAddStation = () => {
        setStations([
            ...stations,
            { station: '', station_id: '', stationHandler: [], selectedDestinationHandler: null, notifyChecked: false }
        ]);
        setFormData(prevFormData => ({
            ...prevFormData,
            all_stations: [
                ...prevFormData.all_stations,
                { station_name: '', handler_id: '', notify_status: '0', type: 'Station' } // Default notify_status to "0"
            ]
        }));
        setFormEdit(true)
    };
    const handleDeleteStation = (index) => {
        // Remove from stations array
        setStations(prevStations => prevStations.filter((_, idx) => idx !== index));

        // Remove from formData.all_stations
        setFormData(prevFormData => {
            const updatedStations = prevFormData.all_stations.filter((_, idx) => idx !== index);
            return { ...prevFormData, all_stations: updatedStations };
        });
    };

    const handleStationChange = (index, selected) => {
        const selectedDestination = getDestination.find(option => option.value === selected.value);
        setStations(prevStations =>
            prevStations.map((station, idx) =>
                idx === index
                    ? {
                        ...station,
                        station: selected.value,
                        station_id: selectedDestination.station_id,
                        stationHandler: selectedDestination ? selectedDestination.address : [],
                        selectedDestinationHandler: null
                    }
                    : station
            )
        );

        setFormData(prevFormData => {
            const updatedStations = [...prevFormData.all_stations];
            if (!updatedStations[index]) {
                updatedStations[index] = {};
            }
            // Ensure the object at the specific index exists, and set station_name
            updatedStations[index] = {
                ...updatedStations[index],       // Keep other existing properties
                station_name: selected.value,   // Set station_name explicitly
            };

            return { ...prevFormData, all_stations: updatedStations };
        });
        onFormEdit(true);
        setFormEdit(true);
    };

    const handleHandlerChange = (index, selected) => {
        setStations(prevStations =>
            prevStations.map((station, idx) =>
                idx === index
                    ? { ...station, selectedDestinationHandler: selected }
                    : station
            )
        );

        setFormData(prevFormData => {
            const updatedStations = [...prevFormData.all_stations];
            updatedStations[index] = {
                ...updatedStations[index],
                handler_id: selected.value
            };
            return { ...prevFormData, all_stations: updatedStations };
        });
        onFormEdit(true);
        setFormEdit(true);
    };
    const handleNotifyChange = (index, checked) => {
        setStations(prevStations =>
            prevStations.map((station, idx) =>
                idx === index
                    ? { ...station, notifyChecked: checked }
                    : station
            )
        );

        setFormData(prevFormData => {
            const updatedStations = [...prevFormData.all_stations];
            updatedStations[index] = {
                ...updatedStations[index],
                notify_status: checked ? '1' : '0'
            };
            return { ...prevFormData, all_stations: updatedStations };
        });
    };
    // STATION SECTION

    // Email array start
    const handleEmailChange = (index, value) => {
        setInputAddress((prev) => {
            const updatedEmails = [...prev.handler_email_id];
            updatedEmails[index] = value;
            return { ...prev, handler_email_id: updatedEmails };
        });
    };

    const addEmailField = () => {
        setInputAddress((prev) => ({
            ...prev,
            handler_email_id: [...prev.handler_email_id, '']
        }));
    };

    const removeEmailField = (index) => {
        setInputAddress((prev) => ({
            ...prev,
            handler_email_id: prev.handler_email_id.filter((_, i) => i !== index)
        }));
    };
    // Email array end

    const validateAddressData = () => {
        let isValid = true;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // Function to validate email
        const validateEmail = (email) => {
            return emailRegex.test(email);
        };
        if (!inputAddress.handler_org_id) {
            toast.error('Please select a Handler name');
            isValid = false;
        }
        // else if (!validateEmail(inputAddress.handler_email_id)) {
        //     toast.error('Please enter valid email address');
        //     isValid = false;
        // }
        else {
            return isValid;
        }
    };

    const addAddress = async (e) => {
        // console.log('444', inputAddress);
        if (validateAddressData()) {
            e.preventDefault();

            let stationid;
            if (addressFor == 'origin' || addressFor == 'OH') {
                stationid = selectedOriginId;
            } else if (addressFor == 'destination' || addressFor == 'DH') {
                stationid = selectedDestinationId;
            } else {
                stationid = selectedStation.station_id
            }
            const transformedEmails = inputAddress.handler_email_id.filter(email => email.trim() !== '');
            const NewInputAddress = { ...inputAddress, handler_email_id: transformedEmails, station_id: stationid };
            if (NewInputAddress) {
                try {
                    const res = await withRFSToken.post(SAVEHANDLER, NewInputAddress)
                        .then(function (res) {
                            // const innerData = res;
                            if (res.data.response_code == 200) {
                                toast.success(res.data.response_msg);
                                const newAddress = res.data.response_data;
                                setAddress(newAddress);
                                // fetchStationData();
                                fetchStationData();
                                if (addressFor === 'origin' || addressFor === 'destination') {

                                }
                                if (addressFor == 'origin') {
                                    setOriginHandler(prevHandlerNames => [
                                        ...prevHandlerNames,
                                        newAddress
                                    ]);
                                    // setTimeout(() => {
                                    //     if (originHandler.length === 1) {
                                    //         setSelectedOriginHandler({ value: newAddress.id, label: newAddress.company_name })
                                    //     }
                                    // }, 500);
                                } else if (addressFor == 'destination') {
                                    setDestinationHandler(prevHandlerNames => [
                                        ...prevHandlerNames,
                                        newAddress
                                    ]);
                                } else if (addressFor == 'OH') {
                                    const transformData = {
                                        value: newAddress?.id,
                                        label: newAddress?.company_name,
                                        email: newAddress?.handler_email_id,
                                        address: newAddress?.address,
                                        number: newAddress?.handler_phone_no,
                                        id: newAddress?.handler_contact_id,
                                        hoid: newAddress?.handler_org_id,
                                    }
                                    setSelectedOriginHandler(transformData);
                                } else if (addressFor == 'DH') {
                                    const transformData = {
                                        value: newAddress?.id,
                                        label: newAddress?.company_name,
                                        email: newAddress?.handler_email_id,
                                        address: newAddress?.address,
                                        number: newAddress?.handler_phone_no,
                                        id: newAddress?.handler_contact_id,
                                        hoid: newAddress?.handler_org_id,
                                    }
                                    setSelectedDestinationHandler(transformData);
                                } else if (addressFor == 'SH') {

                                    const transformData = {
                                        value: newAddress?.id,
                                        label: newAddress?.company_name,
                                        email: newAddress?.handler_email_id,
                                        address: newAddress?.address,
                                        number: newAddress?.handler_phone_no,
                                        id: newAddress?.handler_contact_id,
                                        hoid: newAddress?.handler_org_id,
                                        station_id: newAddress?.station_id
                                    }
                                    // console.log('transformData=1', transformData);
                                    // setSelectedStation(transformData);
                                    setStations(prevStations =>
                                        prevStations.map(station =>
                                            station.station_id === selectedStation.station_id
                                                ? {
                                                    ...station,
                                                    selectedDestinationHandler: transformData, // Update stationHandler with newAddress data
                                                    stationHandler: station.stationHandler.map(handler =>
                                                        handler.handler_org_id === newAddress.handler_org_id
                                                            ? { ...handler, ...newAddress } // Replace the matched handler with newAddress
                                                            : handler // Keep the other handlers unchanged
                                                    ),
                                                }
                                                : station
                                        )
                                    );
                                } else {
                                    // const stnHandler = stations?.find(name => name.station === selectedStation.station);

                                    setStations(prevStations =>
                                        prevStations.map(station =>
                                            station.station === selectedStation.station
                                                ? {
                                                    ...station,
                                                    stationHandler: [...station.stationHandler, newAddress] // Update stationHandler with newAddress data
                                                }
                                                : station
                                        )
                                    );
                                }
                                setInputAddress({
                                    handler_org_id: '', address: '', handler_email_id: [''], handler_phone_no: ''
                                });
                                // console.log(address);
                                addressModalClose();
                            } else {
                                toast.error(res.data.response_msg);
                            }
                        });

                } catch (error) {
                    console.error('Error sending request:', error);
                }
            }
        }
    }
    // ADDRESS MODAL END

    const handleFinish = async () => {
        // setIsLoading(true);
        if (!formEdit) {
            setIsEditable(false)
            onFormEdit(false);
            setFormEdit(false);
            return;
        }
        const findStn = formData.all_stations.length ? formData.all_stations.every(arg => arg.station_name === '' || arg.station_name === null) : false;
        if (findStn) {
            toast.error('Please select a Station name');
            return
        }
        const getOrigin = formData.stations.find(i => i.handler_type == 'Origin');
        const getDest = formData.stations.find(i => i.handler_type == 'Destination');
        const transformedData = {
            ...formData,
            origin_notify_status: formData.origin_notify_status == true ? 1 : 0,
            destination_notify_status: formData.origin_notify_status == true ? 1 : 0,
            all_stations: [
                {
                    handler_feedback_id: getOrigin?.handler_feedback_id,
                    station_name: formData?.origin,
                    type: 'Origin',
                    handler_id: formData?.origin_handler_id,
                    notify_status: formData?.origin_notify_status == true ? 1 : 0
                },
                {
                    handler_feedback_id: getDest?.handler_feedback_id,
                    station_name: formData?.destination,
                    type: 'Destination',
                    handler_id: formData?.destination_handler_id,
                    notify_status: formData?.destination_notify_status == true ? 1 : 0
                },
                ...formData.all_stations
            ],
            // files: [
            //     ...(formData.files || []),
            //     ...filterPrimary.map((file) => ({ id: file.id, primary: file.primary })),
            //     ...restFiles.map((file) => ({ id: file.id, primary: 0 })),
            // ]
        };
        // }

        try {
            const res = await withRFSToken.post(SAVERECOVERY, transformedData)
                .then(function (res) {
                    // setIsLoading(false);
                    if (res.data.response_code == 200) {
                        toast.success(res.data.response_msg);
                        // setTimeout(() => {
                        // window.location.href = '/ServiceRecovery';
                        // }, 1000);
                        setIsEditable(false)
                        // setTabChange(false);
                        onChildAction();
                        onFormEdit(false);
                        setFormEdit(false);
                    } else {
                        toast.error(res.data.response_msg);
                    }
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    return (
        <>
            {/* {console.log('selectedReportHandler', selectedReportHandler)} */}
            <Row className='h-100'>
                <Col lg={6} className=''>
                    <div className='flbg details mb-3'>
                        <div className='ship_head'>
                            <h4 className='d-flex w-100 align-items-center justify-content-between'>
                                Recovery Information
                                {allData?.isEditable &&
                                    <button onClick={handleToggleEdit} className='serv_edit_save ms-2' >
                                        <FontAwesomeIcon icon={faPencilAlt} className='pe-1' /> {isEditable ? "SAVE" : "EDIT"}
                                    </button>
                                }
                            </h4>
                        </div>
                        <Form className='recover_middle overview_details'>
                            {/* MAWB */}
                            <Form.Group className="mb-2" as={Row}>
                                <Col sm={4}>
                                    <Form.Label>Master Airway Bill <span>*</span></Form.Label>
                                </Col>
                                <Col sm={2} className='pe-0'>
                                    <Form.Control
                                        type="number"
                                        name='master_airway_bill_prefix'
                                        maxLength='3'
                                        onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 3); }}
                                        onChange={handleInputChange}
                                        value={formData?.master_airway_bill_prefix || ''}
                                        disabled={!isEditable}
                                    />
                                </Col>
                                <Col className='add_hifen' sm={6}>
                                    <Form.Control
                                        type="text"
                                        name='master_airway_bill_no'
                                        maxLength={9}
                                        onChange={handleInputChange}
                                        value={formData?.master_airway_bill_no || ''}
                                        disabled={!isEditable}
                                    />
                                </Col>
                            </Form.Group>

                            {/* Flight Prefix and Number */}
                            <Form.Group as={Row} className="mb-2">
                                <Col sm={4} className='pe-0'>
                                    <Form.Label>Flight - Number <span>*</span></Form.Label>

                                </Col>
                                <Col sm={2}>
                                    <Select
                                        options={getOwnerCodes}
                                        onChange={(selected) => {
                                            setFormData(prev => ({ ...prev, flight_prefix: selected.value }));
                                        }}
                                        placeholder="Flight"
                                        className='autoslct w-100'
                                        name="flight_prefix"
                                        value={getOwnerCodes.find(option => option.value === formData?.flight_prefix) || ''}
                                        isDisabled={!isEditable}
                                    />
                                </Col>
                                <Col className='add_hifent' sm={6}>
                                    <Form.Control
                                        type="text"
                                        name='flight_no'
                                        maxLength='8'
                                        onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 8); }}
                                        value={formData?.flight_no || ''}
                                        onChange={handleInputChange}
                                        disabled={!isEditable}
                                    />
                                </Col>
                            </Form.Group>

                            {/* Flight Date */}
                            <Form.Group className="mb-2" as={Row}>
                                <Col sm="4">
                                    <Form.Label>Flight Date <span>*</span></Form.Label>
                                </Col>
                                <Col sm="8">
                                    <Form.Control
                                        type="date"
                                        name="flight_date"
                                        value={formData?.flight_date || ''}
                                        onChange={handleInputChange}
                                        disabled={!isEditable}
                                    />
                                </Col>
                            </Form.Group>
                            {allData?.isEditable == false &&
                                <>
                                    <Form.Group className="mb-2" as={Row}>
                                        <Col sm="4">
                                            <Form.Label>Reporting Station</Form.Label>
                                        </Col>
                                        <Col sm="8">
                                            <Select
                                                options={getDestination}
                                                // onChange={(selected) => {
                                                //     setFormData(prevFormData => ({
                                                //         ...prevFormData,
                                                //         reported_station: selected.value,
                                                //     }));
                                                // }}
                                                onChange={(selected) => {
                                                    const selectedDestination = getDestination.find(option => option.value === selected.value);
                                                    setReportHandler(selectedDestination ? selectedDestination.address : []);
                                                    setSelectedReportId(selectedDestination.station_id);

                                                    if (selectedDestination && selectedDestination.address.length === 1) {
                                                        const autoSelectedHandler = {
                                                            value: selectedDestination.address[0].id,
                                                            label: selectedDestination.address[0].company_name,
                                                            email: selectedDestination.address[0].handler_email_id,
                                                            address: selectedDestination.address[0].address,
                                                            number: selectedDestination.address[0].handler_phone_no,
                                                            id: selectedDestination.address[0].id,
                                                            hoid: selectedDestination.address[0].handler_org_id,
                                                        };
                                                        setSelectedReportHandler(autoSelectedHandler);

                                                        setFormData(prevFormData => ({
                                                            ...prevFormData,
                                                            reported: selected.value,
                                                            report_handler_id: selectedDestination.address[0].id
                                                        }));
                                                    } else {
                                                        // Clear handler selection if multiple or no handlers
                                                        setSelectedReportHandler(null);
                                                        setFormData(prevFormData => ({
                                                            ...prevFormData,
                                                            reported: selected.value,
                                                            report_handler_id: ''
                                                        }));
                                                    }
                                                    onFormEdit(true);
                                                    setFormEdit(true);
                                                }}
                                                placeholder="Reporting Station"
                                                className='autoslct w-100 p-0'
                                                name="reported"
                                                value={getDestination.find(option => option.value === formData?.reported) || ''}
                                                // isDisabled={!isEditable}
                                                isDisabled
                                            />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className='mb-2'>
                                        <Col sm={4} className='pe-0 position-relative'>
                                            <label className="form-label">Reporting Handler Name <span className='me-1'></span>
                                            </label>
                                        </Col>
                                        <Col sm={6} className='position-relative'>
                                            <Select
                                                options={reportHandler?.map(handler => ({
                                                    value: handler?.id,
                                                    label: handler?.company_name,
                                                    email: handler?.handler_email_id,
                                                    address: handler?.address,
                                                    number: handler?.handler_phone_no,
                                                    id: handler?.id,
                                                    hoid: handler?.handler_org_id,
                                                }))}
                                                onChange={(selected) => {
                                                    // const updatedData = { ...formData, origin_handler: selected.label };
                                                    // setFormData(updatedData);
                                                    setSelectedReportHandler(selected);
                                                    setFormData(prevFormData => {
                                                        const newFormData = { ...prevFormData, report_handler_id: selected.value };
                                                        // const keyData = JSON.parse(localStorage.getItem(keyType)) || { Form: {} };
                                                        // keyData.Form = newFormData;
                                                        // localStorage.setItem(keyType, JSON.stringify(keyData));

                                                        return newFormData;
                                                    });
                                                    onFormEdit(true);
                                                    setFormEdit(true);
                                                }}
                                                placeholder="Handler Name"
                                                className='autoslct w-100'
                                                name="origin_handler_id"
                                                value={selectedReportHandler ? { value: selectedReportHandler.value, label: selectedReportHandler.label } : ''}
                                                // isDisabled={!originHandler.length || !isEditable}
                                                isDisabled
                                            />
                                        </Col>
                                        <Col sm={2} className='d-flex align-items-center'>
                                            {/* {formData?.origin && isEditable && (
                                        <Link to='#' onClick={() => addressModalOpen('origin')} className='raad_adrss'>+ Add</Link>
                                    )} */}
                                            {selectedOriginHandler &&
                                                (selectedOriginHandler?.email.some(e => e.trim() !== "")
                                                    ? <Link to='#' onClick={isEditable ? () => addressModalOpen('OH') : (e) => e.preventDefault()}><img src={MailGreen} className='mail_icon' /></Link>
                                                    : <Link to='#' onClick={isEditable ? () => addressModalOpen('OH') : (e) => e.preventDefault()}><img src={MailRed} className='mail_icon' /></Link>
                                                )
                                            }
                                        </Col>
                                    </Form.Group>
                                </>
                            }
                            {/* Origin & Handler */}
                            <Form.Group as={Row} className="mb-2">
                                <Col sm={4} className='pe-0'>
                                    <Form.Label>Origin <span>*</span></Form.Label>
                                </Col>
                                <Col sm={8}>
                                    <Select
                                        options={getDestination}
                                        onChange={(selected) => {
                                            const selectedDestination = getDestination.find(option => option.value === selected.value);
                                            setOriginHandler(selectedDestination ? selectedDestination.address : []);
                                            setSelectedOriginId(selectedDestination.station_id);
                                            setSelectedOriginHandler(null);
                                            setFormData(prev => ({ ...prev, origin: selected.value }));
                                            onFormEdit(true);
                                            setFormEdit(true);
                                        }}
                                        placeholder="Origin"
                                        className='autoslct w-100'
                                        name="origin"
                                        value={getDestination.find(option => option.value === formData?.origin) || ''}
                                        isDisabled={!isEditable}
                                    />
                                </Col>
                                {/* {console.log('selectedOriginHandler', selectedOriginHandler)} */}
                            </Form.Group>

                            <Form.Group as={Row} className='mb-2'>
                                <Col sm={4} className='pe-0 position-relative'>
                                    <label className="form-label">
                                        Origin Handler Name <span className='me-1'></span>
                                    </label>
                                </Col>
                                <Col sm={6} className='position-relative'>
                                    <Select
                                        options={originHandler.map(handler => ({
                                            value: handler?.id,
                                            label: handler?.company_name,
                                            email: handler?.handler_email_id,
                                            address: handler?.address,
                                            number: handler?.handler_phone_no,
                                            id: handler?.id,
                                            hoid: handler?.handler_org_id,
                                        }))}
                                        onChange={(selected) => {
                                            setSelectedOriginHandler(selected);
                                            setFormData(prev => ({ ...prev, origin_handler_id: selected.value }));
                                            onFormEdit(true);
                                            setFormEdit(true);
                                        }}
                                        placeholder="Handler Name"
                                        className='autoslct w-100'
                                        name="origin_handler_id"
                                        value={selectedOriginHandler ? { value: selectedOriginHandler.value, label: selectedOriginHandler.label } : ''}
                                        isDisabled={!originHandler.length || !isEditable}
                                    />
                                </Col>
                                <Col sm={2} className='d-flex align-items-center'>
                                    {formData?.origin && isEditable && (
                                        <Link to='#' onClick={() => addressModalOpen('origin')} className='raad_adrss'>+ Add</Link>
                                    )}
                                    {selectedOriginHandler &&
                                        (selectedOriginHandler?.email.some(e => e.trim() !== "")
                                            ? <Link to='#' onClick={isEditable ? () => addressModalOpen('OH') : (e) => e.preventDefault()}><img src={MailGreen} className='mail_icon' /></Link>
                                            : <Link to='#' onClick={isEditable ? () => addressModalOpen('OH') : (e) => e.preventDefault()}><img src={MailRed} className='mail_icon' /></Link>
                                        )
                                    }
                                </Col>
                            </Form.Group>

                            {/* Destination & Handler */}
                            <Form.Group as={Row} className="mb-2">
                                <Col sm={4} className='pe-0'>
                                    <Form.Label>Destination <span>*</span></Form.Label>
                                </Col>
                                <Col sm={8}>
                                    <Select
                                        options={getDestination}
                                        onChange={(selected) => {
                                            const selectedDestination = getDestination.find(option => option.value === selected.value);
                                            setDestinationHandler(selectedDestination ? selectedDestination.address : []);
                                            setSelectedDestinationId(selectedDestination.station_id);
                                            setSelectedDestinationHandler(null);
                                            setFormData(prev => ({ ...prev, destination: selected.value }));
                                            onFormEdit(true);
                                            setFormEdit(true);
                                        }}
                                        placeholder="Origin"
                                        className='autoslct w-100'
                                        name="origin"
                                        value={getDestination.find(option => option.value === formData?.destination) || ''}
                                        isDisabled={!isEditable}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row}>
                                <Col sm={4} className='pe-0 position-relative'>
                                    <label className="form-label">
                                        Destination Handler Name <span></span>
                                    </label>
                                </Col>
                                <Col sm={6} className='position-relative'>
                                    <Select
                                        options={destinationHandler.map(handler => ({
                                            value: handler?.id,
                                            label: handler?.company_name,
                                            email: handler?.handler_email_id,
                                            address: handler?.address,
                                            number: handler?.handler_phone_no,
                                            id: handler?.id,
                                            hoid: handler?.handler_org_id,
                                        }))}
                                        onChange={(selected) => {
                                            setSelectedDestinationHandler(selected);
                                            setFormData(prev => ({ ...prev, destination_handler_id: selected.value }));
                                            onFormEdit(true);
                                            setFormEdit(true);
                                        }}
                                        placeholder="Handler Name"
                                        className='autoslct w-100'
                                        name="origin_handler_id"
                                        value={selectedDestinationHandler ? { value: selectedDestinationHandler.value, label: selectedDestinationHandler.label } : ''}
                                        isDisabled={!destinationHandler.length || !isEditable}
                                    />
                                </Col>
                                <Col sm={2} className='d-flex align-items-center'>
                                    {formData?.destination && isEditable && (
                                        <Link to='#' onClick={() => addressModalOpen('destination')} className='raad_adrss'>+ Add</Link>
                                    )}
                                    {selectedDestinationHandler &&
                                        (selectedDestinationHandler?.email.some(e => e.trim() !== "")
                                            ? <Link to='#' onClick={isEditable ? () => addressModalOpen('DH') : (e) => e.preventDefault()}><img src={MailGreen} className='mail_icon' /></Link>
                                            : <Link to='#' onClick={isEditable ? () => addressModalOpen('DH') : (e) => e.preventDefault()}><img src={MailRed} className='mail_icon' /></Link>
                                        )
                                    }
                                </Col>
                            </Form.Group>
                            {/* repeat same structure with isDisabled={!isEditable} */}

                            {/* Station Loop */}
                            {stations.map((station, index) => (
                                <div key={index}>
                                    <Form.Group as={Row} className="my-3 add_station position-relative">
                                        <Col sm="4" className='pe-0'>
                                            <Form.Label>Station <span>*</span></Form.Label>
                                            <Select
                                                options={getDestination}
                                                onChange={(selected) => handleStationChange(index, selected)}
                                                placeholder="Destination"
                                                className='autoslct w-100'
                                                name={`station-${index}`}
                                                value={getDestination.find(option => option.value === station.station) || ''}
                                                isDisabled={!isEditable}
                                            />
                                        </Col>
                                        <Col sm="7" className='pe-0 position-relative'>
                                            <label className="form-label">
                                                Station Handler Name <span></span>
                                                {station.station && isEditable && (
                                                    <Link to='#' onClick={() => addressModalOpen('station', station, index)} className='raad_adrss'>+ Add</Link>
                                                )}
                                            </label>
                                            <Select
                                                options={station.stationHandler.map(handler => ({
                                                    value: handler.id,
                                                    label: handler.company_name,
                                                    email: handler.handler_email_id,
                                                    address: handler.address,
                                                    number: handler.handler_phone_no,
                                                    id: handler.id,
                                                    hoid: handler.handler_org_id,
                                                    station_id: handler.station_id
                                                }))}
                                                onChange={(selected) => handleHandlerChange(index, selected)}
                                                placeholder="Handler Name"
                                                className='autoslct w-100'
                                                name={`station_handler-${index}`}
                                                value={station.selectedDestinationHandler ? { value: station.selectedDestinationHandler.value, label: station.selectedDestinationHandler.label } : ''}
                                                isDisabled={!station.stationHandler.length || !isEditable}
                                            />
                                        </Col>
                                        <Col sm="1" className='align-self-center mt-20'>
                                            {station.selectedDestinationHandler &&
                                                (station.selectedDestinationHandler?.email.some(e => e.trim() !== "")
                                                    ? <Link to='#' onClick={() => addressModalOpen('SH', station.selectedDestinationHandler)}><img src={MailGreen} /></Link>
                                                    : <Link to='#' onClick={() => addressModalOpen('SH', station.selectedDestinationHandler)}><img src={MailRed} /></Link>
                                                )
                                            }
                                        </Col>

                                        <Link to="#" onClick={() => handleDeleteStation(index)} className='recovery_trash' style={{ pointerEvents: isEditable ? 'auto' : 'none', opacity: isEditable ? 1 : 0.5 }}>
                                            <img src={Trash} />
                                        </Link>
                                    </Form.Group>
                                </div>
                            ))}

                            <Button variant="outline-primary" className='more_btn mt-3' onClick={handleAddStation} disabled={!isEditable}>
                                Add More Station's
                            </Button>
                        </Form>
                    </div>
                    <div className='flbg mt-3'>
                        <div className='ship_head'>
                            <h4 className='d-flex w-100 justify-content-between align-items-center'>
                                Extra Details
                                {allData?.isEditable &&
                                    <button onClick={handleToggleEdit} className='serv_edit_save ms-2' >
                                        <FontAwesomeIcon icon={faPencilAlt} className='pe-1' /> {isEditable ? "SAVE" : "EDIT"}
                                    </button>
                                }
                            </h4>
                        </div>

                        <Form.Group as={Row} className="mb-2">
                            <Col sm={4} className='pe-0'>
                                <Form.Label>Nature of Goods <span></span></Form.Label>
                            </Col>
                            <Col sm={8}>
                                <Form.Control
                                    type="text"
                                    name='nature_of_goods'
                                    // maxLength='8'
                                    // onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 8); }}
                                    value={formData?.nature_of_goods || ''}
                                    onChange={handleInputChange}
                                    disabled={!isEditable}
                                />
                            </Col>
                            {/* </Form.Group>
                                <Form.Group className="mb-2"> */}
                        </Form.Group>
                        <Form.Group as={Row} className="mb-2">
                            <Col sm={4} className='pe-0'>
                                <Form.Label>CUS <span></span></Form.Label>
                            </Col>
                            <Col sm={8}>
                                <Form.Control
                                    type="text"
                                    name='cus'
                                    // maxLength='8'
                                    // onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 8); }}
                                    value={formData?.cus || ''}
                                    onChange={handleInputChange}
                                    disabled={!isEditable}
                                />
                            </Col>
                            {/* </Form.Group>
                                                        <Form.Group className="mb-2"> */}
                        </Form.Group>

                        <Form.Group as={Row} className="mb-2">
                            <Col sm={4} className='pe-0'>
                                <Form.Label>SHC <span></span></Form.Label>
                            </Col>
                            <Col sm={8}>
                                <Select
                                    options={getShc}
                                    value={getShc.filter(item => formData?.shc_id?.includes(item.value))}
                                    onChange={(selected) => {
                                        const selectedIds = selected.map(item => item.value);
                                        setFormData((prevFormData) => ({
                                            ...prevFormData,
                                            shc_id: selectedIds
                                        }));
                                        onFormEdit(true);
                                        setFormEdit(true);
                                    }}
                                    labelledBy="Select "
                                    isMulti
                                    className='multiselect_brd w-100'
                                    isDisabled={!isEditable}
                                />
                            </Col>
                            {/* </Form.Group>
                                                        <Form.Group className="mb-2"> */}
                        </Form.Group>
                        <Form.Group as={Row} className='mb-2'>
                            <Col sm={4} className=''>
                                <Form.Label>Commodity Type <span></span></Form.Label>
                            </Col>
                            <Col sm={8}>
                                <Select
                                    options={commodityType}
                                    onChange={(selected) => {
                                        setFormData(prev => ({
                                            ...prev,
                                            commodity_type: selected.value
                                        }))
                                        onFormEdit(true);
                                        setFormEdit(true);
                                    }}
                                    placeholder="Commodity Type"
                                    className='autoslct w-100 p-0'
                                    name="commodity_type"
                                    value={commodityType.find(option => option.value == formData?.commodity_type) || ''}
                                    isDisabled={!isEditable}
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-2">
                            <Col sm={4} className='pe-0'>
                                <Form.Label>Movement Type <span></span></Form.Label>
                            </Col>
                            <Col sm={8}>
                                <Select
                                    options={movementType}
                                    onChange={(selected) => {
                                        setFormData(prev => ({
                                            ...prev,
                                            movement_type: selected.value
                                        }))
                                        onFormEdit(true);
                                        setFormEdit(true);
                                    }}
                                    placeholder="Movement Type"
                                    className='autoslct w-100 p-0'
                                    name="movement_type"
                                    value={movementType.find(option => option.value == formData?.movement_type) || ''}
                                    isDisabled={!isEditable}
                                />
                            </Col>
                            {/* </Form.Group>
                                <Form.Group className="mb-2"> */}
                        </Form.Group>
                        <Form.Group as={Row} className='mb-2'>
                            <Col sm={4} className=''>
                                <Form.Label>Recovery Information <span></span></Form.Label>
                            </Col>
                            <Col sm={8}>
                                <Select
                                    options={recoveryInfo}
                                    onChange={(selected) => {
                                        setFormData(prev => ({
                                            ...prev,
                                            recovery_information: selected.value
                                        }))
                                        onFormEdit(true);
                                        setFormEdit(true);
                                    }}
                                    placeholder="Recovery Information"
                                    className='autoslct w-100 p-0'
                                    name="recovery_information"
                                    value={recoveryInfo.find(option => option.value == formData?.recovery_information) || ''}
                                    isDisabled={!isEditable}
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-2">
                            <Col sm={4} className='pe-0'>
                                <Form.Label>Agent <span></span></Form.Label>
                            </Col>
                            <Col sm={8}>
                                <Form.Control
                                    type="text"
                                    name='agent'
                                    // maxLength='8'
                                    // onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 8); }}
                                    value={formData?.agent || ''}
                                    onChange={handleInputChange}
                                    disabled={!isEditable}
                                />
                            </Col>
                            {/* </Form.Group>
                                <Form.Group className="mb-2"> */}
                        </Form.Group>
                        <Form.Group as={Row} className='mb-2'>
                            <Col sm={4} className=''>
                                <Form.Label>Road Feeder <span></span></Form.Label>
                            </Col>
                            <Col sm={8}>
                                <Form.Control
                                    type="text"
                                    name='road_feeder'
                                    // maxLength='8'
                                    // onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 8); }}
                                    value={formData?.road_feeder || ''}
                                    onChange={handleInputChange}
                                    disabled={!isEditable}
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group className="mb-2" as={Row}>
                            <Col sm={4}>
                                <Form.Label>Consignee <span></span></Form.Label>
                            </Col>
                            <Col sm={8}>
                                <Form.Control
                                    type="text"
                                    name='consignee'
                                    // maxLength='8'
                                    // onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 8); }}
                                    value={formData?.consignee || ''}
                                    onChange={handleInputChange}
                                    disabled={!isEditable}
                                />
                            </Col>

                        </Form.Group>
                    </div>
                </Col>

                {/* Incident Info */}
                <Col lg={6} className=''>
                    <div className='flbg details h-100'>
                        <div className='ship_head'>
                            <h4 className='d-flex w-100 align-items-center justify-content-between'>
                                Incident Information
                                {allData?.isEditable &&
                                    <button onClick={handleToggleEdit} className='serv_edit_save ms-2' >
                                        <FontAwesomeIcon icon={faPencilAlt} className='pe-1' /> {isEditable ? "SAVE" : "EDIT"}
                                    </button>
                                }
                            </h4>
                        </div>
                        <Form className='recover_middle'>
                            <Form.Group as={Row} className="mb-2">
                                <Col sm={4}>
                                    <Form.Label>Total MAWB Pieces <span>*</span></Form.Label>
                                </Col>
                                <Col sm={8}>
                                    <Form.Control
                                        type="number"
                                        name='total_mawb_pieces'
                                        value={formData?.total_mawb_pieces || ''}
                                        onChange={handleInputChange}
                                        disabled={!isEditable}
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className='mb-2'>
                                <Col sm={4}>
                                    <Form.Label>Weight (Kg) <span>*</span></Form.Label>
                                </Col>
                                <Col sm={8}>
                                    <Form.Control
                                        type="number"
                                        name='total_mawb_wght'
                                        value={formData?.total_mawb_wght || ''}
                                        onChange={handleInputChange}
                                        disabled={!isEditable}
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-2">
                                <Col sm={4}>
                                    <Form.Label>Pieces involved <span>*</span></Form.Label>
                                </Col>
                                <Col sm={8}>
                                    <Form.Control
                                        type="number"
                                        name='pieces_involved'
                                        value={formData?.pieces_involved || ''}
                                        onChange={handleInputChange}
                                        disabled={!isEditable}
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className='mb-2'>
                                <Col sm={4}>
                                    <Form.Label>Involved Weight (Kg) <span>*</span></Form.Label>
                                </Col>
                                <Col sm={8}>
                                    <Form.Control
                                        type="number"
                                        name='pieces_wght'
                                        value={formData?.pieces_wght || ''}
                                        onChange={handleInputChange}
                                        disabled={!isEditable}
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group className="mb-2 recover_ascp" as={Row}>
                                <Col sm={4}>
                                    <Form.Label>Recovery Aspects <span>*</span></Form.Label>
                                </Col>
                                <Col sm={8}>
                                    {/* {['MSCA', 'FDCA', 'DMA'].map(option => (
                                    <Form.Check
                                        key={option}
                                        inline
                                        type="checkbox"
                                        label={option}
                                        value={option}
                                        name='recovery_aspects'
                                        onChange={handleInputChange}
                                        checked={formData?.recovery_aspects?.includes(option)}
                                        disabled={!isEditable}
                                    />
                                ))} */}
                                    <Select
                                        options={recoveryAspects}
                                        value={recoveryAspects.filter(item => formData?.recovery_aspects?.includes(item.value))}
                                        onChange={(selected) => {
                                            const selectedIds = selected.map(item => item.value);
                                            setFormData((prevFormData) => ({
                                                ...prevFormData,
                                                recovery_aspects: selectedIds
                                            }));
                                            onFormEdit(true);
                                            setFormEdit(true);
                                        }}
                                        labelledBy="Select "
                                        isMulti
                                        className='multiselect_brd w-100'
                                        isDisabled={!isEditable}
                                    />
                                    {/* <MultiSelect
                                        options={recoveryAspects}
                                        value={recoveryAspects.filter(item => formData?.recovery_aspects?.includes(item.value))}
                                        onChange={(selected) => {
                                            const selectedIds = selected.map(item => item.value);
                                            setFormData((prevFormData) => ({
                                                ...prevFormData,
                                                recovery_aspects: selectedIds
                                            }));
                                        }}
                                        labelledBy="Select "
                                        className='multiselect_brd w-100'
                                        isDisabled={!isEditable}
                                    /> */}
                                </Col>
                            </Form.Group>
                            {formData?.recovery_aspects?.includes(126) &&
                                <Form.Group className="mb-2 recover_ascp" as={Row}>
                                    <Col sm={4}>
                                        <Form.Label>Other Aspects <span>*</span></Form.Label>
                                    </Col>
                                    <Col sm={8}>
                                        <Select
                                            options={otherAspects}
                                            value={otherAspects.filter(item => formData?.recovery_aspects_others?.includes(item.value))}
                                            onChange={(selected) => {
                                                const selectedIds = selected.map(item => item.value);
                                                setFormData((prevFormData) => ({
                                                    ...prevFormData,
                                                    recovery_aspects_others: selectedIds
                                                }));
                                                onFormEdit(true);
                                                setFormEdit(true)
                                            }}
                                            labelledBy="Select"
                                            className='multiselect_brd w-100'
                                            isDisabled={!isEditable}
                                        />
                                    </Col>
                                </Form.Group>
                            }
                            <Form.Group as={Row}>
                                <Col sm={4}>
                                    <Form.Label>Remarks</Form.Label>
                                </Col>
                                <Col sm={8}>
                                    <Form.Control as="textarea" name='comment' rows={5} onChange={handleInputChange} value={formData?.comment} disabled={!isEditable} />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                </Col>
            </Row>
            <Modal show={addressModalShow} onHide={addressModalClose} centered className='addfrom'>
                <Modal.Header closeButton >
                    <Modal.Title>{addressFor == 'OH' || addressFor == 'DH' || addressFor == 'SH' ? 'Edit' : 'Add'} Address - {addressFor == 'origin' || addressFor == 'OH' ? orgLabel : (addressFor == 'destination' || addressFor == 'DH' ? destLabel : getDestination.find(nm => nm.station_id === selectedStation?.station_id)?.label)}</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <Form.Group className='mb-2'>
                        <Form.Label>Handler Name <span>*</span></Form.Label>
                        {/* <Form.Control type="text" onChange={handleAddressChange} name='company_name' placeholder="Company Name" /> */}
                        {handlerList.length === 0 ?
                            <Form.Control
                                type="text"
                                onChange={(e) => setInputAddress(prevFormData => ({ ...prevFormData, handler_org_id: e.target.value }))}
                                name='handler_org_id'
                                placeholder="Handler Name"
                            />
                            :
                            <Select
                                options={handlerList}
                                onChange={(selected) => {
                                    setInputAddress(prevFormData => {
                                        const newFormData = { ...prevFormData, handler_org_id: selected.value }; // , handler_email_id: selected.email 
                                        return newFormData;
                                    });
                                }}
                                placeholder="Select Handler"
                                className='select_handler'
                                name='handler_org_id'
                                isDisabled={['OH', 'DH', 'SH'].includes(addressFor)}
                                value={handlerList.find(option => option.value === inputAddress.handler_org_id) || ''}
                            />
                        }
                    </Form.Group>

                    <Form.Group className='mb-2'>
                        <Form.Label>Email ID  <Link to="#" className="raad_adrss" onClick={addEmailField}>+ Add Email</Link></Form.Label>
                        {/* <Form.Control type="text" onChange={handleAddressChange} name='handler_email_id' placeholder="E-mail" value={inputAddress.handler_email_id || ''} /> */}
                        {inputAddress?.handler_email_id?.map((email, index) => (
                            <div key={index} className="d-flex align-items-center position-relative mb-2">
                                <Form.Control
                                    type="text"
                                    placeholder="E-mail"
                                    value={email}
                                    onChange={(e) => handleEmailChange(index, e.target.value)}
                                    className=""
                                />
                                {inputAddress.handler_email_id.length > 1 && (

                                    <Link to="#" onClick={() => removeEmailField(index)} className="email_del"> <FontAwesomeIcon icon={faCircleXmark} /> </Link>

                                )}
                            </div>
                        ))}
                    </Form.Group>

                    <Form.Group className='mb-2'>
                        <Form.Label>Address </Form.Label>
                        <Form.Control type="text" onChange={handleAddressChange} name='address' placeholder="Address" value={inputAddress.address || ''} />
                    </Form.Group>


                    <Form.Group className='mb-2'>
                        <Form.Label>Telephone No</Form.Label>
                        <Form.Control
                            type="number"
                            onChange={handleAddressChange}
                            name='handler_phone_no'
                            onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12); }}
                            placeholder="Number"
                            value={inputAddress.handler_phone_no || ''}
                        />
                    </Form.Group>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={addAddress}  >
                        {addressFor == 'OH' || addressFor == 'DH' || addressFor == 'SH' ? 'Update' : 'Add'} Address
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default Details